import React from "react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";

import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";

import makeGetConfigRequest from "./core/config/config";
import appConfigStore from "./core/config/appConfigStore";

async function enableMocking() {
  if (process.env.NODE_ENV !== "local") {
    return;
  }
  const { worker } = await import("./mocks/index");
  return worker.start({
    onUnhandledRequest: "bypass",
  });
}

const render = async () => {
  const config = await makeGetConfigRequest();
  appConfigStore.config = config;

  if (appConfigStore.config.SENTRY_DSN) {
    Sentry.init({
      dsn: appConfigStore.config.SENTRY_DSN,
      tracesSampleRate: 1,
      sampleRate: 1.0,
      debug: false,
    });
  }
  const importApp = await import("./App");
  const App = importApp.default;
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

enableMocking().then(() => render());
